import { render, staticRenderFns } from "./PositionAttachedRolesTable.vue?vue&type=template&id=ef42bf04&scoped=true"
import script from "./PositionAttachedRolesTable.vue?vue&type=script&lang=js"
export * from "./PositionAttachedRolesTable.vue?vue&type=script&lang=js"
import style0 from "./PositionAttachedRolesTable.vue?vue&type=style&index=0&id=ef42bf04&prod&lang=css"
import style1 from "./PositionAttachedRolesTable.vue?vue&type=style&index=1&id=ef42bf04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef42bf04",
  null
  
)

export default component.exports